import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'RepeaterConfiguratorController',
            RepeaterConfiguratorController
        );

    function RepeaterConfiguratorController($scope, $translate) {
        var vm = this;

        init();

        function init() {
            vm.configuration = vm.configuration || {};
            vm.initialConfiguration = vm.initialConfiguration || {};

            vm.buildConfig = buildConfig;
            vm.loadInitialConfig = loadInitialConfig;

            vm.switchDay = switchDay;
            vm.switchMonth = switchMonth;
            vm.isDaySelected = function (day) {
                return isItemSelected(day, vm.selectedDays);
            };
            vm.isMonthSelected = function (month) {
                return isItemSelected(month, vm.selectedMonths);
            };

            $scope.$watch(
                function () {
                    return [
                        vm.frequency,
                        vm.interval,
                        vm.variant,
                        vm.which,
                        vm.what,
                        vm.selectedMonths,
                        vm.selectedDays,
                        vm.weeklyOnMonday,
                        vm.weeklyOnTuesday,
                        vm.weeklyOnWednesday,
                        vm.weeklyOnThursday,
                        vm.weeklyOnFriday,
                        vm.weeklyOnSaturday,
                        vm.weeklyOnSunday,
                    ];
                },
                function () {
                    vm.buildConfig();
                },
                true
            );

            $scope.$watch(
                function () {
                    return [vm.initialConfiguration];
                },
                function () {
                    if (vm.initialConfiguration) {
                        vm.loadInitialConfig();
                    }
                },
                true
            );

            vm.frequency = '';
            vm.interval = 1;
            vm.variant = 'each';
            vm.which = 'first';
            vm.what = 'monday';
            vm.selectedMonths = [];
            vm.selectedDays = [];

            vm.weeklyOnMonday = false;
            vm.weeklyOnTuesday = false;
            vm.weeklyOnWednesday = false;
            vm.weeklyOnThursday = false;
            vm.weeklyOnFriday = false;
            vm.weeklyOnSaturday = false;
            vm.weeklyOnSunday = false;

            vm.availableMonths = [
                [
                    {
                        number: 1,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.jan'
                        ),
                    },
                    {
                        number: 2,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.feb'
                        ),
                    },
                    {
                        number: 3,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.mar'
                        ),
                    },
                    {
                        number: 4,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.apr'
                        ),
                    },
                ],
                [
                    {
                        number: 5,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.may'
                        ),
                    },
                    {
                        number: 6,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.jun'
                        ),
                    },
                    {
                        number: 7,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.jul'
                        ),
                    },
                    {
                        number: 8,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.aug'
                        ),
                    },
                ],
                [
                    {
                        number: 9,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.sep'
                        ),
                    },
                    {
                        number: 10,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.oct'
                        ),
                    },
                    {
                        number: 11,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.nov'
                        ),
                    },
                    {
                        number: 12,
                        display: $translate.instant(
                            'periodic_tasks.repeater_configurator.short_months.dec'
                        ),
                    },
                ],
            ];

            vm.frequencies = [
                {
                    id: 'daily',
                    name: $translate.instant(
                        'periodic_tasks.repeater_configurator.daily'
                    ),
                },
                {
                    id: 'weekly',
                    name: $translate.instant(
                        'periodic_tasks.repeater_configurator.weekly'
                    ),
                },
                {
                    id: 'monthly',
                    name: $translate.instant(
                        'periodic_tasks.repeater_configurator.monthly'
                    ),
                },
                {
                    id: 'yearly',
                    name: $translate.instant(
                        'periodic_tasks.repeater_configurator.yearly'
                    ),
                },
            ];
        }

        function loadInitialConfig() {
            var repeaterConfig = vm.initialConfiguration;

            vm.frequency = repeaterConfig.frequency;
            vm.interval = repeaterConfig.interval;

            if ('weekly' === vm.frequency) {
                vm.weeklyOnMonday =
                    repeaterConfig.days_of_week.includes('monday');
                vm.weeklyOnTuesday =
                    repeaterConfig.days_of_week.includes('tuesday');
                vm.weeklyOnWednesday =
                    repeaterConfig.days_of_week.includes('wednesday');
                vm.weeklyOnThursday =
                    repeaterConfig.days_of_week.includes('thursday');
                vm.weeklyOnFriday =
                    repeaterConfig.days_of_week.includes('friday');
                vm.weeklyOnSaturday =
                    repeaterConfig.days_of_week.includes('saturday');
                vm.weeklyOnSunday =
                    repeaterConfig.days_of_week.includes('sunday');
            }

            if ('yearly' === vm.frequency) {
                vm.selectedMonths = repeaterConfig.months;
            }

            if (['monthly', 'yearly'].indexOf(vm.frequency) > -1) {
                vm.variant = repeaterConfig.variant;
                if (vm.variant === 'each') {
                    vm.selectedDays = repeaterConfig.days;
                }
                if (vm.variant === 'on_the') {
                    vm.which = repeaterConfig.which;
                    vm.what = repeaterConfig.what;
                }
            }
        }

        function buildConfig() {
            var data: any = {};

            if (vm.frequency) {
                data.frequency = vm.frequency;
            }
            if (vm.interval) {
                data.interval = vm.interval;
            }

            if ('weekly' === vm.frequency) {
                data.days_of_week = [];

                if (vm.weeklyOnMonday) {
                    data.days_of_week.push('monday');
                }
                if (vm.weeklyOnTuesday) {
                    data.days_of_week.push('tuesday');
                }
                if (vm.weeklyOnWednesday) {
                    data.days_of_week.push('wednesday');
                }
                if (vm.weeklyOnThursday) {
                    data.days_of_week.push('thursday');
                }
                if (vm.weeklyOnFriday) {
                    data.days_of_week.push('friday');
                }
                if (vm.weeklyOnSaturday) {
                    data.days_of_week.push('saturday');
                }
                if (vm.weeklyOnSunday) {
                    data.days_of_week.push('sunday');
                }
            }

            if ('yearly' === vm.frequency) {
                data.months = vm.selectedMonths;
            }

            if (['monthly', 'yearly'].indexOf(vm.frequency) > -1) {
                data.variant = vm.variant;
                if (vm.variant === 'each') {
                    data.days = vm.selectedDays;
                }
                if (vm.variant === 'on_the') {
                    data.which = vm.which;
                    data.what = vm.what;
                }
            }

            vm.configuration = data;
        }

        function switchDay(day) {
            if (day <= 31) {
                vm.selectedDays = isItemSelected(day, vm.selectedDays)
                    ? unselectItem(day, vm.selectedDays)
                    : selectItem(day, vm.selectedDays);
            }
        }

        function switchMonth(month) {
            if (month <= 12) {
                vm.selectedMonths = isItemSelected(month, vm.selectedMonths)
                    ? unselectItem(month, vm.selectedMonths)
                    : selectItem(month, vm.selectedMonths);
            }
        }

        function isItemSelected(item, items) {
            return !!items.find(function (i) {
                return i === item;
            });
        }

        function selectItem(item, items) {
            return items.concat([item]);
        }

        function unselectItem(item, items) {
            return items.filter(function (i) {
                return i !== item;
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/periodic_tasks/repeater_configurator/repeater_configurator.controller.ts